export default __webpack_public_path__ + "static/media/AvatarKids-10.c531fb13.png";